import { ModalController } from 'ionic-angular';

export interface OpenQuestionnaireModalOptions {
  submitEndpoint?: string;
  submittedStorageKey?: string;
  title?: string;
  subtitle?: string;
}

/** Opens the shared questionnaire modal (lazy-loaded QuestionnairemodalPage). */
export function openQuestionnaireModal(
  modalCtrl: ModalController,
  options: OpenQuestionnaireModalOptions = {},
): Promise<any> {
  const modal = modalCtrl.create('QuestionnairemodalPage', options, {
    cssClass: 'questionnaire-modal',
    enableBackdropDismiss: true,
  });
  modal.present();
  return new Promise((resolve) => modal.onDidDismiss(resolve));
}

/** Returns true if the user already submitted (per storage key). */
export function isQuestionnaireSubmitted(storageKey: string = 'appQuestionnaireSubmittedV1'): boolean {
  try {
    return localStorage.getItem(storageKey) === '1';
  } catch (e) {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/components/app-questionnaire/open-questionnaire-modal.ts